import { gql } from 'graphql-request'
import { GenericBlock } from '../generic'

export const scrollingContentCarouselFragment = gql`
  fragment scrollingContentCarouselFragment on ScrollingContentCarousel {
    id
    title
    subtitle
    ctaLabel
    ctaLink
    content {
      ...content
    }
  }
`

export interface ScrollingContentCarousel
  extends GenericBlock<'ScrollingContentCarousel'> {
  title: string
  subtitle: string
  ctaLabel: string
  ctaLink: string
  content: any[] // Using any for now since Content type is complex
}
